import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizBrowserExport } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'
import Criteria from '../../components/criteria'
import AcceptanceResults from '../../components/acceptanceResults'
import Result from '../../components/result'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/review/result/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('reviewResultLook', record)
        } else {
            record = Session.get('reviewResultLook') || {}
        }
    }
    return record
}

class ReviewResultLook extends WizContainer {

    componentName = 'ReviewResultLook'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { id, processContentId, recordId } = this.state.record
        this.doActions([{
            path: 'counselingProcess/acceptanceResults',
            payload: {
                key: 'reviewAcceptanceResults@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 3
                }
            }
        }, {
            path: 'counselingProcess/evaluationCriteria',
            payload: {
                key: 'reviewEvaluationCriteriaLook@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 3
                }
            }
        }, {
            path: 'counselingProcess/preAuditOrCheckDetail',
            payload: {
                key: 'reviewResultDetail@' + recordId,
                apiParams: {
                    id: recordId
                }
            }
        }, {
            path: 'counselingProcess/getKpiCycleList',
            payload: {
                key: 'getKpiCycleList@' + processContentId,
                apiParams: {
                    fuseTutorId: id
                }
            }
        }, {
            path: 'counselingProcess/cameraList',
            payload: {
                key: 'cameraList@' + processContentId,
                apiParams: {
                    fuseTutorId: id
                }
            }
        }, {
            path: 'counselingProcess/satisfactionEvaluationGetList',
            payload: {
                key: 'satisfactionEvaluationGetList@' + processContentId,
                apiParams: {
                    fuseTutorId: id
                }
            }
        }])
    }

    _exportFilename = (filename) => {
        let { shortName, orgName, preSalesNumber, afterSalesNumber, moduleType } = this.state.record
        return `${filename}-${shortName || orgName}(${preSalesNumber && afterSalesNumber ? preSalesNumber + ',' + afterSalesNumber : preSalesNumber || afterSalesNumber})-${moduleType === 0 ? '销售' : '售后'}.xlsx`
    }

    _onExportResults = (data) => {
        let sheets = data.map((item, index) => {
            let { columns, sheetName, filename, ...rest } = item
            return {
                title: sheetName,
                titleParams: {
                    font: {
                        size: 14, color: { argb: '3A3A3A' }
                    }
                },
                sheetName,
                columns: columns.filter((_, index) => index),
                filename: this._exportFilename(filename),
                ...rest
            }
        })

        WizBrowserExport(sheets)
    }

    _onExportCriteria = (data) => {
        let columns = [{
            headerName: '',
            width: 30,
            field: 'rowIndex',
            hidden: true,
            suppressMovable: true,
            cellStyle: {
                textAlign: 'center',
                padding: '5px 0',
                color: '#595959',
                backgroundColor: '#f0f0f0',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '500',
                boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
            }
        }, {
            headerName: '要素',
            field: 'essentialFactor',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '一级指标',
            field: 'primaryIndex',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '评估标准',
            field: 'evaluationCriteria',
            width: 40,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'left', horizontal: 'center' } }
        }, {
            headerName: '评估结果',
            field: 'results',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '备注',
            field: 'remarks',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }]

        let sheets = data.map((item, index) => {
            let { sheetName, rows } = item
            let rowMergeCell = []
            rows = rows.map((row, index) => {
                let { evaluationCriteria, rowSpans } = row
                row.evaluationCriteria = evaluationCriteria.replaceAll('<br/>', '\n')
                if (row.results === -1) {
                    row.results = ''
                } 
                if (rowSpans.essentialFactorSpan > 1) {
                    rowMergeCell.push(`A${index + 3}:A${index + 2 + rowSpans.essentialFactorSpan}`)
                }
                if (rowSpans.primaryIndexSpan > 1) {
                    rowMergeCell.push(`B${index + 3}:B${index + 2 + rowSpans.primaryIndexSpan}`)
                }
                return row
            })
            return {
                title: sheetName,
                titleParams: {
                    font: {
                        size: 14, color: { argb: '3A3A3A' }
                    }
                },
                sheetName,
                columns: columns.filter((_, index) => index),
                rows,
                rowMergeCell,
                filename: this._exportFilename('检核标准')
            }
        })

        WizBrowserExport(sheets)
    }

    render() {
        let { record } = this.state
        let {
            auditAcceptanceResults,
            kpi,
            camera,
            satisfaction,
            evaluationCriteria,
            result,
            counselingProcessLoading
        } = this.props
        let content = ''
        let data = result && result.data ? result.data : null
        if (result && result.data && result.data.content) {
            content = result.data.content
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <AcceptanceResults
                    data={auditAcceptanceResults.data}
                    title='检核验收结果'
                    type='look'
                    other={{
                        kpi: kpi.data,
                        camera: camera.data,
                        satisfaction: satisfaction.data
                    }}
                    onExport={this._onExportResults}
                />
                <Criteria data={evaluationCriteria.data} title='检核标准' type='look' onExport={this._onExportCriteria} />
                <Result title='检核结果' mode='review' type='look' data={data} content={content} />
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId, recordId } = findParamRecord(ownProps.history)
    const evaluationCriteria = modelUtils.getModelEntity(counselingProcess, 'reviewEvaluationCriteriaLook@' + processContentId)
    const auditAcceptanceResults = modelUtils.getModelEntity(counselingProcess, 'reviewAcceptanceResults@' + processContentId)
    const result = modelUtils.getModelEntity(counselingProcess, 'reviewResultDetail@' + recordId)
    const kpi = modelUtils.getModelEntity(counselingProcess, 'getKpiCycleList@' + processContentId)
    const camera = modelUtils.getModelEntity(counselingProcess, 'cameraList@' + processContentId)
    const satisfaction = modelUtils.getModelEntity(counselingProcess, 'satisfactionEvaluationGetList@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        evaluationCriteria,
        auditAcceptanceResults,
        result,
        kpi,
        camera,
        satisfaction,
        ...loading
    }
}

export default connect(mapStateToProps)(ReviewResultLook)


